import apiHandler from "./apiHandler";

const apiCharter = {
  active: (type = "pax") => {
    return new Promise((resolve, reject) => {
      apiHandler
        .get(`/charter/active/${type}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  recent: (type = "pax", hours) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .get(`/charter/recent/${type}${hours ? "/" + hours : ""}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export default apiCharter;
